import { combineReducers } from 'redux';

import { pullRequestAuthorsReducer as pullRequestAuthors } from './reducers/pull-request-authors';
import { pullRequestListDataReducer as pullRequests } from './reducers/pull-request-list';
import { pullRequestPreloadedAuthorReducer as pullRequestPreloadedAuthor } from './reducers/pull-request-preloaded-author';

export * from './actions';
export * from './selectors';
export * from './types';

export const pullRequestListReducer = combineReducers({
  pullRequests,
  pullRequestAuthors,
  pullRequestPreloadedAuthor,
});
